export default function isScrolledController() {
  // Function to check the scroll position and toggle the class
  function toggleScrollClass() {
    if (window.scrollY > 0) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }

  // Run the function once after page load in case the page is already scrolled
  toggleScrollClass();

  // Listen for scroll events to update the class dynamically
  window.addEventListener('scroll', toggleScrollClass);
}
